import React, { useRef } from "react";

import { useAtom } from "jotai";

import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import Layout from "../../../../layout/layout";
import "./calculator.css";

import { loadingState } from "../../../../states/loadingState";

import { Toast } from "primereact/toast";

const Summary = () => {
  const { state } = useLocation();
  const toast = useRef(null);
  const { t } = useTranslation();
  const [isLoading] = useAtom(loadingState);

  return (
    <React.Fragment>
      <Layout>
        <Toast ref={toast} />
        <div className="calculator-container">
          <div style={{ textAlign: "center", marginBottom: "1.5rem" }}>
            <h2 style={{ marginBottom: 8 }}>Solicitud enviada</h2>
            <p style={{ margin: 0, color: "#2a3b4d" }}>
              Se procesarán los datos ingresados y te responderemos a la brevedad.
            </p>
          </div>
          <div style={{ marginBottom: 24 }}>
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: 0 }}>
              <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 20 }}>
                {/* Fila 1: cuotas, cuota, monto */}
                <div className="resultBox" style={{ minWidth: 220, flex: '1 1 220px', maxWidth: 320 }}>
                  <div style={{ fontSize: "1rem", fontWeight: "bold", paddingBottom: 10 }}>{t("entities.applications.installmentsNumber")}</div>
                  <div style={{ fontSize: "1.5rem" }}>{state.installmentsNumber}</div>
                </div>
                <div className="resultBox" style={{ minWidth: 220, flex: '1 1 220px', maxWidth: 320 }}>
                  <div style={{ fontSize: "1rem", fontWeight: "bold", paddingBottom: 10 }}>{t("entities.applications.installmentsAmount")}</div>
                  <div style={{ fontSize: "1.5rem" }}>{state.installmentsAmount.toLocaleString("es-UY", { style: "currency", currency: "UYU" })}</div>
                </div>
                <div className="resultBox" style={{ minWidth: 220, flex: '1 1 220px', maxWidth: 320 }}>
                  <div style={{ fontSize: "1rem", fontWeight: "bold", paddingBottom: 10 }}>{t("entities.applications.amount")}</div>
                  <div style={{ fontSize: "1.5rem" }}>{state.amount.toLocaleString("es-UY", { style: "currency", currency: "UYU" })}</div>
                </div>
              </div>
              <div style={{ height: 20 }} />
              <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 20 }}>
                {/* Fila 2: nombre, apellido, documento */}
                <div className="resultBox" style={{ minWidth: 220, flex: '1 1 220px', maxWidth: 320 }}>
                  <div style={{ fontSize: "1rem", fontWeight: "bold", paddingBottom: 10 }}>{t("entities.applications.beneficiary_Name")}</div>
                  <div style={{ fontSize: "1.5rem" }}>{state.beneficiary_Name}</div>
                </div>
                <div className="resultBox" style={{ minWidth: 220, flex: '1 1 220px', maxWidth: 320 }}>
                  <div style={{ fontSize: "1rem", fontWeight: "bold", paddingBottom: 10 }}>{t("entities.applications.beneficiary_LastName")}</div>
                  <div style={{ fontSize: "1.5rem" }}>{state.beneficiary_LastName}</div>
                </div>
                <div className="resultBox" style={{ minWidth: 220, flex: '1 1 220px', maxWidth: 320 }}>
                  <div style={{ fontSize: "1rem", fontWeight: "bold", paddingBottom: 10 }}>{t("entities.applications.beneficiary_DocumentNumber")}</div>
                  <div style={{ fontSize: "1.5rem" }}>{state.beneficiary_DocumentNumber}</div>
                </div>
              </div>
              <div style={{ height: 20 }} />
              <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 20 }}>
                {/* Fila 3: teléfono, dirección */}
                <div className="resultBox" style={{ minWidth: 220, flex: '1 1 220px', maxWidth: 320 }}>
                  <div style={{ fontSize: "1rem", fontWeight: "bold", paddingBottom: 10 }}>{t("entities.applications.beneficiary_Phone")}</div>
                  <div style={{ fontSize: "1.5rem" }}>{state.beneficiary_Phone}</div>
                </div>
                <div className="resultBox" style={{ minWidth: 220, flex: '1 1 220px', maxWidth: 320 }}>
                  <div style={{ fontSize: "1rem", fontWeight: "bold", paddingBottom: 10 }}>{t("entities.applications.beneficiary_Address")}</div>
                  <div style={{ fontSize: "1.5rem" }}>{state.beneficiary_Address}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </React.Fragment>
  );
};

export default Summary;
